export const SIGNALR_MESSAGE_TYPES = {
    NOTIFICATION: "Notification",
    NAS_TRANSACTIONS_CHECKINS: "NAS_TRANSACTIONS_CHECKINS",
    NAS_TRANSACTIONS_ADD_CLINIC_QUE: "NAS_TRANSACTIONS_ADD_CLINIC_QUE",
    NAS_TRANSACTIONS_ADD_GUIDANCE_QUE: "NAS_TRANSACTIONS_ADD_GUIDANCE_QUE",
}